import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core'
import {
  getActiveClient, getStoredUser
} from "../../../api-client/core/authentication/utils";
import {request} from "../../../api-client";
import FilePondUploader from '../FilePondUploader';
import GlobalSnackbar from "../Snackbar/GlobalSnackbar";
import localization from "../../../config/localization";


export default class extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			biometricPhotos: [],
			biometricPhotoFiles: [],
			isUploadingBiometric: false,
			showBiometricUploader: false
		}
	}

	handleBiometricSubmit = async () => {
    this.setState({ isUploadingBiometric: true });
    
		if (this.state.biometricPhotoFiles.length < 5 || this.state.biometricPhotoFiles.length > 10) {
			GlobalSnackbar.show({
				message: "Debes subir entre 5 y 10 fotos de tu rostro",
				type: "error"
			});
			return;
		}

    try {
      const response = await request.user.generateBiometricAvatar({
        photoIds: this.state.biometricPhotoFiles.map(photo => photo.id),
        clientId: getActiveClient()
      });
      
      if (response.success) {

        GlobalSnackbar.show({
          message: "Tu perfil de reconocimiento facial se está generando.",
          type: "success"
        });

        this.setState({
          showBiometricUploader: false,
          biometricPhotos: [],
          biometricPhotoFiles: []
        });
      }
    } catch (error) {
      console.error('Error al generar el avatar:', error);
      GlobalSnackbar.show({
				message: "Error al generar el perfil de reconocimiento facial",
				type: "error"
			});

      this.props.onClose(false);
    } finally {
      this.setState({ isUploadingBiometric: false });
      this.props.onClose(true);
    }
  }

	onFileAdd = (files) => this.setState({ biometricPhotoFiles: files })
  onFileDelete = (fileId) => this.setState({ biometricPhotoFiles: this.state.biometricPhotoFiles.filter(file => file.id !== fileId) })


  render() {

    if (!getStoredUser()) this.props.onClose();

    return (
      <Dialog open={this.props.open} onClose={() => this.props.onClose()}>
        <DialogTitle>Activar el reconocimiento facial</DialogTitle>
        <DialogContent>
		<div>
			<p>Necesitamos que cargues entre 5 y 10 fotos tuyas para generar tu perfil de reconocimiento facial. Esto nos permitirá encontrarte y mostrarte automáticamente todas las imágenes en las que aparecés dentro de la plataforma. Una vez que subas las fotos, en pocos minutos vas a poder buscarte desde el menú de tu perfil, opción ¡Encontrarme!</p>
			<br/>
      <p><strong>Recomendaciones para mejores resultados:</strong></p>
			<ul>
				<li>Busca un lugar con buena iluminación</li>
				<li>Intenta que las fotos sean solo de tu rostro</li>
				<li>Evita usar filtros o efectos en las fotos</li>
				<li>Sube fotos con diferentes ángulos de tu rostro</li>
			</ul>
		</div>
    {getStoredUser() && getStoredUser().person_association_status == "failed" &&
      <div>
        <p><strong>No pudimos generar tu perfil de reconocimiento facial. Por favor, intenta nuevamente con imagenes que sigan las recomendaciones.</strong></p>
      </div>
    }
		<br/>
		<FilePondUploader
			onIdChange={(batchFiles) => {
				this.onFileAdd(batchFiles)
			}}
			isMultiple={true}
			maxFiles={20}
			batchUpload={true}
			allowedTypes={["image/*"]}
			onBatchFileDelete={(fileId) => this.onFileDelete(fileId)}
			clientId={getActiveClient()}
		/>
        </DialogContent>
        <DialogActions>
					<Button onClick={() => this.props.onClose()}>Cancel</Button>	
					<Button onClick={() => this.handleBiometricSubmit()}>Generar</Button>
        </DialogActions>
      </Dialog>
    )
  }
}
